import styled from 'styled-components'
import { zoning_indice_sources } from '@popety-io/types'

/** Custom badge colors — NOT mapped to theme tokens */
const BADGE_COLORS: Record<string, { bg: string; color: string }> = {
  estimate: { bg: '#f0f0f0', color: '#888' },
  llm: { bg: '#e8f4fd', color: '#0088cc' },
  geoportal: { bg: '#f0e8fa', color: '#7733bb' },
  manual: { bg: '#e0f5f3', color: '#0d9488' },
  old: { bg: '#f0f0f0', color: '#888' },
}

export const BadgeContainer = styled.span<{
  $source: zoning_indice_sources
  $faded?: boolean
}>`
  display: inline-flex;
  align-items: center;
  padding: 1px 4px;
  border-radius: ${({ theme }) => theme.borderRadius.small};
  font-size: 8px;
  font-weight: ${({ theme }) => theme.typography.fontWeight.bold};
  letter-spacing: 0.2px;
  line-height: 1;
  cursor: help;
  opacity: ${({ $faded }) => ($faded ? 0.6 : 1)};
  background: ${({ $source }) => BADGE_COLORS[$source]?.bg || '#f0f0f0'};
  color: ${({ $source }) => BADGE_COLORS[$source]?.color || '#888'};
`

export const EditBadgeContainer = styled.span<{ $faded?: boolean }>`
  display: inline-flex;
  align-items: center;
  gap: 2px;
  padding: 2px 5px 2px 4px;
  border-radius: 7px;
  background: #fef3cd;
  border: 0.7px solid #e6a817;
  cursor: help;
  opacity: ${({ $faded }) => ($faded ? 0.6 : 1)};
`

export const EditBadgeLabel = styled.span`
  font-size: 8px;
  font-weight: 700;
  color: #b58a00;
  letter-spacing: 0.2px;
  line-height: 9px;
`

export { BADGE_COLORS }
